module.exports = __webpack_public_path__ + "img/ic_exit.a048e405.svg";